import { useLocation, useNavigate } from "react-router-dom";
import * as CrudServices from '../../../../../service/crudServices';
import * as OrderCRUDServices from '../../../../../service/orderCRUDServices';
import * as TripPlanningServices from '../../../../../service/order/tripPlanningServices';
import { useSelector } from "react-redux";
import { useCallback, useEffect, useMemo, useState } from "react";
import { ROUTES } from "../../../../../constant/routeConstant";
import { validationTripPlanning } from "../validation-trip-planning";
import { t } from "i18next";
import { validateSubmit } from "../../../../../util/Util";
import _ from "lodash";

const useAddTripPlanning = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { token } = useSelector((state) => state.auth);

  const [depotId, setDepotId] = useState(location?.state);
  const [depotLat, setDepotLat] = useState(null);
  const [depotLong, setDepotLong] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [listOrder, setListOrder] = useState([]);
  const [orderSelected, setOrderSelected] = useState([]);
  const [daSelected, setDASelected] = useState([]);
  const [listDA, setListDA] = useState([]);
  const [modalViewDetailOrder, setModalViewDetailOrder] = useState(false);
  const [dataViewDetailOrder, setDataViewDetailOrder] = useState({});
  const [tripPlanName, setTripPlanName] = useState("");
  const [tab, setTab] = useState(1);
  const [isCheckedAll, setIsCheckedAll] = useState(false);
  const [dataViewDetailDA, setDataViewDetailDA] = useState({});
  const [modalViewDetailDA, setModalViewDetailDA] = useState(false);
  const [errorTripPlanName, setErrorTripPlanName] = useState(null);
  const [errorListOrder, setErrorListOrder] = useState(null);

  const [isModalSuccessAdd, setIsModalSuccessAdd] = useState(false);
  const [messageSuccessAdd, setMessageSuccessAdd] = useState("");
  const [isModalFailed, setIsModalFailed] = useState(false);
  const [messageFailed, setMessageFailed] = useState("");
  const [processSelectAll, setProcessSelectAll] = useState(false);
  const [jmlDataOrder, setJmlOrder] = useState(null);
  const [modalPopUpMaxOrderSelected, setModalPopUpMaxOrderSelected] = useState(false);
  const [finalOrderSelected, setFinalOrderSelected] = useState([]);
  const [isGetRoutes, setIsGetRoutes] = useState(true);

  const [searchRecommendation, setSearchRecommendation] = useState([]);
  const [isViewDetailPhoto, setIsViewDetailPhoto] = useState(false);
  const [photoPath, setPhotoPath] = useState("");

  const getDetailDepot = async (id) => {
    const { ok, data } = await CrudServices.getDetail(token, `depot-configuration`, id);
    
    if (ok) {
      setDepotLat(data?.depot_profile?.depot_latitude);
      setDepotLong(data?.depot_profile?.depot_longitude)
    }
    setIsLoading(false);
  }

  const getListOrder = useCallback( async (datas) => {
    const filter = datas ? `depot_id eq ${depotId}, customer_name lk ${datas}` : `depot_id eq ${depotId}` 
    const params = { 
      page: 1, 
      limit: 100, 
      order: `id desc`, 
      filter: filter
    }

    const {ok, data} = await OrderCRUDServices.orderGetList(token, `order-all-trip`, params);

    if (ok && data !== null) {
      setListOrder(data);
    } else {
      setListOrder([]);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[listOrder, depotId]);

  const getCountData = useCallback(async() => {
    const params = { 
      page: 1, 
      limit: 100, 
      order: `id desc`, 
      filter: `depot_id eq ${depotId}`
    }
    const responseInitiate = await OrderCRUDServices.orderInitiate(token, `order-all-trip`, params);

    if (responseInitiate.ok) {
      setJmlOrder(responseInitiate?.data?.count_data);
    } else {
      setJmlOrder(null);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[jmlDataOrder]);

  useEffect(() => {
    setDepotId(location?.state);
    
    const fetchData = async () => {
      await getDetailDepot(location?.state);
      await getCountData();
    }

    fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  useEffect(() => {
    if (depotId !== null) {
      getListOrder();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[depotId])

  const backToList = () => {
    navigate(ROUTES.TRIP_PLANNING.LIST);
  }

  const viewDetailListOrder = useCallback(async (itemId) => {
    const { 
      ok, 
      data 
    } = 
    await TripPlanningServices.viewDetailListOrder(token, itemId);

    if (ok && data !== null) {
      setModalViewDetailOrder(true);
      setDataViewDetailOrder(data);
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[modalViewDetailOrder, dataViewDetailOrder]);

  const closeModalDetailOrder = useCallback(() => {
    setModalViewDetailOrder(false);
    setDataViewDetailOrder({});
    
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[modalViewDetailOrder, dataViewDetailOrder]);

  const jmlOrderTerpilih = useMemo(() => {
    if (orderSelected && orderSelected.length > 0) {
      return orderSelected.length;
    } else {
      return 0
    }
  },[orderSelected]);

  const checkBoxListOrder = useCallback((item) => {
    const arr = orderSelected;
    
    if (jmlOrderTerpilih !== 0) {
      if (arr.length < 100) {
        let idx = arr.findIndex(el => el.id === item?.order_id);

        if (idx !== -1) {
          const orderFiltered = arr.filter(el => el.id !== item?.order_id);
          setOrderSelected(orderFiltered);
          return;
        } else {
          arr.push({
            id: item?.order_id,  
            latt: item?.latitude, 
            long: item?.longitude, 
            order_name: `Order - ${item?.order_number}`
          });
          setOrderSelected([...arr]);
        }
      } else {
        let idx = arr.findIndex(el => el.id === item?.order_id);

        if (idx !== -1) {
          const orderFiltered = arr.filter(el => el.id !== item?.order_id);
          setOrderSelected(orderFiltered);
          return;
        } else {
          setModalPopUpMaxOrderSelected(true);
        }
      }
    } else {
      arr.push({
          id: item?.order_id,  
          latt: item?.latitude, 
          long: item?.longitude, 
          order_name: `Order - ${item?.order_number}`
      });
      setOrderSelected([...arr]);
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[orderSelected, depotLat, depotLong, jmlOrderTerpilih]);

  const getMultipleDistance = useCallback(async () => {
    let distanceService = new window.google.maps.DistanceMatrixService();
    const arr = [];

    // Define the origin and destination coordinates
    let origin = new window.google.maps.LatLng(
      Number(depotLat),
      Number(depotLong)
    );

    for (let i = 0; i < orderSelected.length; i++) {
      let destination = new window.google.maps.LatLng(
        Number(orderSelected[i].latt),
        Number(orderSelected[i].long)
      );
      
      // Create a request object
      let request = {
        origins: [origin],
        destinations: [destination],
        travelMode: "DRIVING",
        unitSystem: window.google.maps.UnitSystem.METRIC,
      };

      // Call the getDistanceMatrix method of the DistanceMatrixService to get the distance
      distanceService.getDistanceMatrix(request, function (response, status) {
        if (status === "OK") {
          let distance = response?.rows[0]?.elements[0]?.distance?.text;
          
          arr.push({
            id: orderSelected[i].id, 
            route_distance: distance ? distance.toUpperCase() : '0 KM', 
            latt: orderSelected[i].latt, 
            long: orderSelected[i].long, 
            order_name: `Order - ${orderSelected[i].order_name}` 
          });
          
          setFinalOrderSelected([...arr]);
        } else {
          console.log("Error:", status);
        }
      });

    }
    setIsGetRoutes(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[orderSelected, depotLat, 
    depotLong, processSelectAll, 
    finalOrderSelected, isGetRoutes
  ]);

  const getListDriverAssociate = useCallback(async (payload, page, limit) => {
    const params = { page, limit }
    const { status, list } = await TripPlanningServices.getListDriverAssociate(token, payload, params);
    
    if (status) {
      if (list && list?.length > 0) {
        setListDA(list);
      } else {
        setListDA([]);
      }
    } else {
      setListDA([]);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[listDA]);

  useEffect(() => {
    if (orderSelected && orderSelected.length > 0) {
      const listOrder = orderSelected?.map((el) => el?.id);
      const payload = {
        depot_id: depotId,
        list_order_id: listOrder
      }
      getListDriverAssociate(payload, 1, 100);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[orderSelected, depotId]);

  const handleNext = useCallback(() => {
    let errors = {};
    let keys = {
      trip_plan_name: tripPlanName,
      list_order: orderSelected,
    }

    for(const key in keys){
      const option = validationTripPlanning(key, keys[key], t);
      const currentError = option;
      errors = { ...currentError, ...errors };
    }
    if (validateSubmit(errors)) {
      setTab(2);
    } else {
      setErrorTripPlanName(errors?.trip_plan_name);
      setErrorListOrder(errors?.list_order);
    }
    
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[tab, tripPlanName, orderSelected, errorListOrder, errorTripPlanName]);

  const handleBack = useCallback(() => {
    setTab(1);
    
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[tab]);

  const handleCheckSelectAll = useCallback(() => {
    const listSelected = orderSelected;

    if (jmlOrderTerpilih === 100) {
      setOrderSelected([]);
    } else if(jmlOrderTerpilih === 0){
      const newData = listOrder.map((item) => {
        return {
          id: item?.order_id, 
          latt: item?.latitude, 
          long: item?.longitude, 
          order_name: `Order - ${item?.order_number}` 
        }
      });
      setOrderSelected([...newData]);
      setIsCheckedAll(true)
    } else {
      const newListOrder = listOrder.map((item) => {
        return {
          id: item?.order_id, 
          latt: item?.latitude, 
          long: item?.longitude, 
          order_name: `Order - ${item?.order_number}` 
        }
      });

      const diff = _.differenceBy(newListOrder, orderSelected, 'id')
      const jmlTotal = orderSelected.length + diff.length;

      if (jmlTotal > 100) {
        const outOfBond = jmlTotal - 100;
        for (let i = 0; i < outOfBond; i++) {
          diff.pop();
        }
        const newDataSelected = [...diff, ...listSelected];
        setOrderSelected([...newDataSelected]);
      } else {
        const newSelected = [...diff, ...listSelected];
        setOrderSelected([...newSelected]);
      }
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[jmlOrderTerpilih, orderSelected, listOrder, isCheckedAll]);

  const checkIsExist = (id) => {
    if (orderSelected && orderSelected.length > 0) {
      let isExist = orderSelected.some((el) => el.id === id);
      return isExist;
    } else {
      return false;
    }
  };

  const checkBoxListDA = useCallback((id) => {
    const arr = daSelected;
    
    if (arr && arr.length > 0) {
      if (arr.length < 100) {
        let idx = arr.indexOf(id);
      if (idx !== -1) {
        const newArr = arr.filter(el => el !== id);
        setDASelected([...newArr]);
      } else {
        arr.push(id);
        setDASelected([...arr]);
      }
      } else {
        setModalPopUpMaxOrderSelected(true);
      }
    } else {
      arr.push(id);
      setDASelected([...arr]);
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[daSelected, modalPopUpMaxOrderSelected]);

  const onChangePlanName = useCallback((evt) => {
    let error = validationTripPlanning('trip_plan_name', evt.target.value, t);
    setTripPlanName(evt.target.value);
    setErrorTripPlanName(error?.trip_plan_name)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[tripPlanName, errorTripPlanName]);

  const onSubmit = useCallback( async () => {
    if (isGetRoutes) {
      getMultipleDistance();
    } else {

    const data = {
      depot_id: depotId,
      trip_plan_name: tripPlanName,
      list_order: finalOrderSelected.map((el) => { return ({id: el?.id, route_distance: el?.route_distance})}),
      list_delivery_associate: daSelected
    }
    const { ok, message } = await TripPlanningServices.insertData(token, data);
    if (ok) {
      setIsModalSuccessAdd(true);
      setMessageSuccessAdd(message)
    } else {
      setIsModalFailed(true);
      setMessageFailed(message);
    }
      setIsGetRoutes(true)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[tripPlanName, orderSelected, 
    depotId, daSelected, token, 
    isModalSuccessAdd, isModalFailed,
    messageFailed, messageSuccessAdd,
    isGetRoutes, finalOrderSelected
  ]);

  const viewDetailDA = useCallback((data) => {
    setModalViewDetailDA(true);
    setDataViewDetailDA(data);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[modalViewDetailDA, dataViewDetailDA]);

  const closeModalViewDetailDA = useCallback(() => {
    setDataViewDetailDA({});
    setModalViewDetailDA(false);
    
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[modalViewDetailDA, dataViewDetailDA]);

  const checkIsExistListDA = (id) => {
    if (daSelected && daSelected.length > 0) {
      let isExist = daSelected.includes(id);
      return isExist;
    } else {
      return false;
    }
  }

  const handleOKSuccess = useCallback(() => {
    setIsModalSuccessAdd(false);
    setMessageSuccessAdd(null)
    navigate(ROUTES.TRIP_PLANNING.LIST);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[isModalSuccessAdd, messageSuccessAdd]);

  const onSearchListOrder = useCallback(async (data) => {
    const params = { 
      page: 1, 
      limit: 10, 
      filter: `depot_id eq ${location?.state}, customer_name lk ${data}` 
    };

    if(data && data.length >= 3){
      const {ok, data} = 
      await OrderCRUDServices.orderGetList(token,`order`,params); 
      
      if (ok && data !== null ) {
        const newList = data.map((item) => {
          return {
            value: item?.customer_name,
            label: item?.customer_name
          }
        })
        setSearchRecommendation(newList)
      } else {
        setSearchRecommendation([])
      }
    } else {
      setSearchRecommendation([]);
      getListOrder()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[searchRecommendation, listOrder]);

  const onSelectSearchRecommendation = useCallback((data) => {
    if (jmlOrderTerpilih < 100) {
      getListOrder(data);
      setIsCheckedAll(false)
    } else {
      getListOrder(data);
      setIsCheckedAll(true);
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[listOrder, isCheckedAll, jmlOrderTerpilih]);

  const onPreviewPhoto = useCallback((photo) => {
    setPhotoPath(photo);
    console.log(photo);
    setIsViewDetailPhoto(true);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[isViewDetailPhoto, photoPath]);

  const onClosePreviewPhoto = useCallback(() => {
    setPhotoPath("");
    setIsViewDetailPhoto(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[isViewDetailPhoto, photoPath]);

  return {
    depotId,
    location,
    depotLat,
    depotLong,
    isLoading,
    listOrder,
    orderSelected,
    jmlOrderTerpilih,
    tab,
    isCheckedAll,
    listDA,
    modalViewDetailOrder,
    dataViewDetailOrder,
    tripPlanName,
    modalViewDetailDA,
    dataViewDetailDA,
    errorTripPlanName,
    isModalSuccessAdd,
    isModalFailed,
    messageFailed,
    messageSuccessAdd,
    processSelectAll,
    searchRecommendation,
    jmlDataOrder,
    modalPopUpMaxOrderSelected,
    isViewDetailPhoto,
    photoPath,
    onSearchListOrder,
    onSelectSearchRecommendation,
    setIsModalSuccessAdd,
    setIsModalFailed,
    setModalViewDetailOrder,
    checkIsExist,
    backToList,
    viewDetailListOrder,
    checkBoxListOrder,
    handleNext,
    handleBack,
    handleCheckSelectAll,
    closeModalDetailOrder,
    onChangePlanName,
    onSubmit,
    checkBoxListDA,
    viewDetailDA,
    closeModalViewDetailDA,
    checkIsExistListDA,
    handleOKSuccess,
    setModalPopUpMaxOrderSelected,
    onPreviewPhoto,
    onClosePreviewPhoto
  }
}

export default useAddTripPlanning;